import React from 'react';
import Phonebg from './Phonebg_space';
import "../src/foodbank-css/Registration.css";
import { useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function RegOtp() {
    const [verify, setverify] = useState(false);
    const [newverify, setnewverify] = useState(false);
    const [otp, setOtp] = useState(['', '', '', '']);
    const location = useLocation();
    const navigate = useNavigate();
    const userId = location.state && location.state.userId;
    const userEmail = location.state && location.state.userEmail;
    const [loading, setLoading] = useState(false);
    const inputRefs = useRef(Array(4).fill(null).map(() => React.createRef()));

    const handleChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (index < 3 && value !== '') {
            inputRefs.current[index + 1].current.focus();
        }
    };

    const resendMail = async () => {
        setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1000));
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/users/resend-mail/${userId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: userEmail,
            }),
        });
        const data = await response.json();
        if (response.status === 200) {
            setLoading(false);
            setnewverify(true);
        } else {
            setLoading(false);
            toast.error('Verification failed', {
                style: {
                    border: '1px solid #D2042D',
                    padding: '16px',
                    color: '#D2042D',
                },
                iconTheme: {
                    primary: '#D2042D',
                    secondary: '#FFFAEE',
                },
            });
        }
    }

    const handleSubmit = async () => {
        setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1000));
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/user/verify-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: userEmail,
                code: otp.join(''),
            }),
        });
        const data = await response.json();
        if (response.status === 200) {
            setLoading(false);
            const userId = data.userId;
            setverify(true);
            navigate('/Reg2', { state: { userEmail: userEmail, userId: userId } })
        } else {
            setLoading(false);
            toast.error('Verification failed:', data.message, {
                style: {
                    border: '1px solid #D2042D',
                    padding: '16px',
                    color: '#D2042D',
                },
                iconTheme: {
                    primary: '#D2042D',
                    secondary: '#FFFAEE',
                },
            });
        }
    };

    return (
        <main className="reg-main">
            <div className="reg-form-space">
                <img src="foodbank-images/foodbank-logo.png" alt="" className="reg-logo" />
                <h2 className="registration-subheading">
                    OTP Verification
                </h2>
                <p className="regristration-descriptive-text">
                    Enter the OTP sent to <span>{userEmail}</span>
                </p>
                <form action="" className="registration-form">
                    <div className="otp-inputs">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                type="tel"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleChange(index, e.target.value)}
                                ref={inputRefs.current[index]}
                            />
                        ))}
                    </div>
                    <span className='reg-form-sign-space'>
                        <p>Didn’t receive the OTP? </p>
                        <a onClick={resendMail} href="#">Resend</a>
                    </span>
                    {loading && (
                        <div className="preloader-overlay">
                            <div className="preloader"></div>
                        </div>
                    )}
                    <div className='reg-form-btn rfb-otp' onClick={handleSubmit} disabled={loading}>
                        Verify
                    </div>
                </form>
            </div>
            <Phonebg></Phonebg>
            {newverify ? <div className="verification-modal-bg" onClick={() => { setnewverify(false) }}>
                <div className="otp-verification-modal">
                    <img src="foodbank-images/check-img.png" alt="" className="otp-check-pic" />
                    <h2>
                        New Otp Request
                    </h2>
                    <p>
                        The new Otp has been sent to your email address
                    </p>
                    <a href="#" onClick={() => { setnewverify(false) }}>
                        Continue
                    </a>
                </div>
            </div> : null}
            {verify ? <div className="verification-modal-bg" onClick={() => { setverify(false) }}>
                <div className="otp-verification-modal">
                    <img src="foodbank-images/check-img.png" alt="" className="otp-check-pic" />
                    <h2>
                        Verification Successful
                    </h2>
                    <p>
                        Great news! Your verification has been successfully completed.
                    </p>
                    <a href="#" onClick={() => { setverify(false) }}>
                        Continue
                    </a>
                </div>
            </div> : null}
        </main>
    )
}
